import "./WireTransferDataTableStyle.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

import React, { useEffect, useRef, useState } from "react";
import { Typography, useTheme } from "@mui/material";

import ArchiveIcon from "@mui/icons-material/Archive";
import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { EnhancedButtonPrimeReact } from "../../EnhancedButtonPrimeReact";
import { EnhancedButtonPrimeReactSeverity } from "../../../common/Common";
import { IAppState } from "../../../store/reducers";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { RequestParams } from "@websential/cosmic-v20";
import { isEqual } from "lodash";
import { useSelector } from "react-redux";

export interface IWireTransferDataTable {
	rows: any;
	columns?: any;
	onRowDeleteClicked?: (params: any) => void;
	onRowEditClicked?: (params: any) => void;
	onRowArchiveClicked?: () => void;
	isLoading?: any;
	onRequestParamsChange?: (params: RequestParams) => void;
	initialPageSize?: number | undefined;
	initialPage?: number;
	totalRecords?: number;
	rowsPerPageOptions?: number[];
	tableScrollHeight?: string;
	showHeaderColumns?: boolean;
	showDeleteIcon?: boolean;
	disabledDeleteIcon?: boolean;
	showArchiveIcon?: boolean;
	showPaginator?: boolean;
	selectedId: string;
	WireTransferTableData: (data: any) => void;
	footer?: any;
}

export const WireTransferDataTable: React.FC<IWireTransferDataTable> = ({
	rows,
	columns,
	onRowDeleteClicked,
	onRowEditClicked,
	onRowArchiveClicked,
	isLoading,
	onRequestParamsChange,
	initialPageSize = 10,
	initialPage = 0,
	totalRecords,
	rowsPerPageOptions,
	tableScrollHeight,
	showHeaderColumns = false,
	showDeleteIcon = true,
	disabledDeleteIcon = false,
	showArchiveIcon = true,
	showPaginator = true,
	selectedId,
	WireTransferTableData,
	footer,
}) => {
	const isAdminUser = useSelector((state: IAppState) => state.user.profile.isSuperStatus)
	const isInitialRequest = useRef(true);
	const [loading, setLoading] = useState(false);
	const theme = useTheme();
	const subMenuVisibility = useSelector(
		(state: IAppState) => state.drawerAction.subMenuVisibility
	);
	const [itemSearch, setItemSearch] = useState("");
	const [wireTransferDataItems, setWireTransferDataItems] = useState<any>(
		rows && rows
	);

	// useEffect(() => {
	// 	WireTransferTableData(wireTransferDataItems);
	// }, [wireTransferDataItems]);


	// useEffect(() => {
	// 	if (!isEqual(rows, wireTransferDataItems)) {
	// 		setWireTransferDataItems([...rows]);
	// 	}
	// }, [rows]);

	useEffect(() => {
		WireTransferTableData(wireTransferDataItems);
	}, [wireTransferDataItems]);

	useEffect(() => {
		if (!isEqual(rows, wireTransferDataItems)) {
			setWireTransferDataItems([...rows]);
		}
	}, [rows]);

	const [requestParams, setRequestParams] = useState<any>({
		first: initialPage,
		rows: initialPageSize,
		page: initialPage,
		sortField: null,
		sortOrder: "asc",
		searchQuery: "",
		filters: {
			name: { value: "", matchMode: "contains" },
			"country.name": { value: "", matchMode: "contains" },
			company: { value: "", matchMode: "contains" },
			"representative.name": { value: "", matchMode: "contains" },
		},
	});

	// const ArchiveIcon = () => (
	// 	<svg
	// 		xmlns="http://www.w3.org/2000/svg"
	// 		width="16"
	// 		height="16"
	// 		fill="currentColor"
	// 		viewBox="0 0 16 16"
	// 	>
	// 		<path d="M2.5 1a1 1 0 0 0-1 1v2a1 1 0 0 0 .293.707L3 5.914V14a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V5.914l1.207-1.207A1 1 0 0 0 14.5 4V2a1 1 0 0 0-1-1h-11zm1 6a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1h-8A.5.5 0 0 1 3.5 7z" />
	// 	</svg>
	// );
	const delEditArchive = (params: any) => {
		// AFTER
		const isDeleteDisabled =
			isAdminUser !== 400 && (params.creditAmount !== null && params.creditAmount !== "" && params.creditAmount !== undefined) ||
			isAdminUser !== 400 && 	(params.debitAmount !== null && params.debitAmount !== "" && params.debitAmount !== undefined);

		return (
			<>
				{/* <EnhancedButtonPrimeReact
					icon={"pi pi-user-edit"}
					onClickHandler={() => onRowEditClicked && onRowEditClicked(params)}
					severity={EnhancedButtonPrimeReactSeverity.Secondary}
					className="p-button-rounded p-button-text w-2rem h-2rem"
					rounded
				/> */}
				{showArchiveIcon && (
					<Button
						icon={<ArchiveIcon />}
						// icon={<ArchiveOutlinedIcon/>}
						onClick={onRowArchiveClicked}
						severity={EnhancedButtonPrimeReactSeverity.Secondary}
						className="p-button-rounded p-button-text w-2rem h-2rem ml-2"
						style={{ fontSize: "16px", color: "grey" }}
						rounded
					/>
				)}
				{showDeleteIcon && (
					<EnhancedButtonPrimeReact
						// icon="pi pi-trash"
						icon="pi pi-times"
						onClickHandler={() =>
							onRowDeleteClicked && onRowDeleteClicked(params)
						}
						severity={EnhancedButtonPrimeReactSeverity.Danger}
						className="p-button-rounded p-button-text w-2rem h-2rem ml-2"
						rounded
						disabled={isDeleteDisabled}
					// disabled={disabledDeleteIcon}
					// disabled={!params.canEdit}
					/>
				)}
			</>
		);
	};
	const renderHeader = () => {
		return (
			<div
				style={{
					display: "flex",
					alignItems: "center",
				}}
			>
				<span
					className="p-input-icon-left w-full"
					style={{ display: "flex", height: "37px" }}
				>
					<i className="pi pi-search" />
					<InputText
						value={itemSearch}
						onChange={(e) => setItemSearch(e.target.value)}
						placeholder={"Search..."}
						className="w-full"
						style={{ borderRadius: "2px 2px 2px 2px" }}
					/>
				</span>
			</div>
		);
	};
	const headerSearch = renderHeader();
	function search(_row: any) {
		return (
			rows &&
			rows.filter(
				(rows: any) =>
					rows.label.props.children
						.toLowerCase()
						.indexOf(itemSearch.toLowerCase()) > -1
			)
		);
	}

	// 	function search(_row: any) {
	// 	return (
	// 		rows &&
	// 		rows.filter((row: any) => {
	// 			// handle string labels
	// 			if (typeof row.label === "string") {
	// 				return row.label
	// 					.toLowerCase()
	// 					.includes(itemSearch.toLowerCase());
	// 			}

	// 			// handle React element labels
	// 			if (row.label?.props?.children) {
	// 				return row.label.props.children
	// 					.toLowerCase()
	// 					.includes(itemSearch.toLowerCase());
	// 			}

	// 			return false;
	// 		})
	// 	);
	// }

	const onPage = (event: any) => {
		// setRequestParams(event);
		setLoading(true);
		//imitate delay of a backend call
		setTimeout(() => {
			setRequestParams({
				...event,
				// searchQuery: itemSearch,
			});
			setLoading(false);
		}, 1000);
	};

	useEffect(() => {
		// if the results fetcher was passed, we can use it to fetch the results.
		if (onRequestParamsChange) {
			// skip the first initial call
			if (isInitialRequest.current === true) {

				isInitialRequest.current = false;
			} else {

				onRequestParamsChange(requestParams);
			}
		}
	}, [onRequestParamsChange, requestParams]);

	const getRowClassName = (data: any) => {
		const isMatch = data.id && selectedId ?
			data.id === selectedId : data.value && selectedId ? data.value === selectedId : false;
		return {
			"highlighted-row": isMatch
		};
	};

	// const [selectedRow, setSelectedRow] = useState(null);
	// const getRowClassName = (rowData: any) => {
	// 	return rowData === selectedRow ? 'highlighted-row' : '';
	// };
	// useEffect(() => {
	// 	if (!selectedId) {
	// 		setSelectedRow(null)
	// 	}
	// }, [selectedId])


	const onCellValueChange = (event: any, rowIndex: number, field: any) => {
		setWireTransferDataItems((prev: any) => {
			const updatedData = [...prev];
			const updatedRow = { ...updatedData[rowIndex], [event.field]: field };
			updatedData[rowIndex] = updatedRow;
			return updatedData;
		});
	};

	const columnsBody = (rowData: any, row: any, x: any) => {
		const debitAmountField = rowData.debitAmount !== null &&
			rowData.debitAmount !== "";

		if (x.field === "creditAmount") {
			if (isAdminUser === 400 && rowData.canEdit) {
				return (
					<InputNumber
						value={rowData.creditAmount}
						onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
						minFractionDigits={2}
						maxFractionDigits={2}
						inputStyle={{ textAlign: "right" }}
					/>
				);
			} else {
				return (
					<span>
						{rowData[x.field] !== null && rowData[x.field] !== undefined
							? Number(rowData[x.field])
								.toFixed(2)
								.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
							: rowData[x.field]}
					</span>
				);
			}
		} else if (x.field === "confirmationNo" && debitAmountField) {
			return (
				<div style={{ position: "relative" }}>
					<Typography sx={{ fontSize: ".875rem" }}>
						{rowData[x.field]}
					</Typography>
					<Typography sx={{ fontSize: ".875rem" }}
						className="debitAmountMessage">
						{rowData.debitAmountMessage}
					</Typography>
				</div>
			);
		} else {
			return <span>{rowData[x.field]}</span>;
		}
	};


	// const columnsBody = (rowData: any, row: any, x: any) => {
	// 	if (x.field === "creditAmount") {
	// 		if (rowData.canEdit) {
	// 			return (
	// 				<InputNumber
	// 					value={rowData[x.field]}
	// 					onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
	// 					minFractionDigits={2}
	// 					maxFractionDigits={2}
	// 					inputStyle={{ textAlign: "right" }}
	// 				/>
	// 			);
	// 		}
	// 	}
	// 	else {
	// 		return (
	// 			<span>
	// 				{rowData[x.field]}
	// 			</span>
	// 		)
	// 	}
	// };

	// const columnsBody = (rowData: any, row: any, x: any) => {
	// 	if (x.field === "creditAmount" && isAdminUser === 400) {
	// 		if (rowData.canEdit) {
	// 			return (
	// 				<InputNumber
	// 					value={rowData.creditAmount}
	// 					onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
	// 					minFractionDigits={2}
	// 					maxFractionDigits={2}
	// 					inputStyle={{ textAlign: "right" }}
	// 				/>
	// 			);
	// 		} else {
	// 			// ← this else was missing — so non-editable rows showed nothing
	// 			return (
	// 				<span>
	// 					{rowData[x.field] !== null && rowData[x.field] !== undefined
	// 						? Number(rowData[x.field])
	// 							.toFixed(2)
	// 							.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
	// 						: rowData[x.field]}
	// 				</span>
	// 			);
	// 		}
	// 	} else {
	// 		return <span>{rowData[x.field]}</span>;
	// 	}
	// };


	// 	const columnsBody = (rowData: any, row: any, x: any) => {
	// 	// Fields that should show debitAmountMessage below them
	// 	const debitMessageFields = ["confirmationNo", "wireAmount", "creditAmount"];

	// 	if (x.field === "creditAmount") {
	// 		if (isAdminUser === 400 && rowData.canEdit) {
	// 			return (
	// 				<>
	// 					<InputNumber
	// 						value={rowData.creditAmount}
	// 						onChange={(e: any) => onCellValueChange(x, row.rowIndex, e.value)}
	// 						minFractionDigits={2}
	// 						maxFractionDigits={2}
	// 						inputStyle={{ textAlign: "right" }}
	// 					/>
	// 					{rowData.debitAmount !== null &&
	// 						rowData.debitAmount !== undefined &&
	// 						rowData.debitAmount !== "" && (
	// 							<Typography
	// 							sx={{
	// 								fontSize:".875rem"
	// 							}}
	// 							className="debitAmountMessage">
	// 								{rowData.debitAmountMessage}
	// 							</Typography>
	// 						)}
	// 				</>
	// 			);
	// 		} else {
	// 			return (
	// 				<>
	// 					<span>
	// 						{rowData[x.field] !== null && rowData[x.field] !== undefined
	// 							? Number(rowData[x.field])
	// 								.toFixed(2)
	// 								.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
	// 							: rowData[x.field]}
	// 					</span>
	// 					{rowData.debitAmount !== null &&
	// 						rowData.debitAmount !== undefined &&
	// 						rowData.debitAmount !== "" && (
	// 								<Typography
	// 							sx={{
	// 								fontSize:".875rem"
	// 							}}
	// 							className="debitAmountMessage">
	// 								{rowData.debitAmountMessage}
	// 							</Typography>
	// 						)}
	// 				</>
	// 			);
	// 		}
	// 	} else if (debitMessageFields.includes(x.field)) {
	// 		return (
	// 			<>
	// 				<span>{rowData[x.field]}</span>
	// 				{rowData.debitAmount !== null &&
	// 					rowData.debitAmount !== undefined &&
	// 					rowData.debitAmount !== "" && (
	// 							<Typography
	// 							sx={{
	// 								fontSize:".875rem"
	// 							}}
	// 							className="debitAmountMessage">
	// 								{rowData.debitAmountMessage}
	// 							</Typography>
	// 					)}
	// 			</>
	// 		);
	// 	} else {
	// 		return <span>{rowData[x.field]}</span>;
	// 	}
	// };

	console.log("rowsss", rows)

	return (
		<>
			<DataTable
				value={rows && columns && wireTransferDataItems && search(wireTransferDataItems)}
				responsiveLayout="scroll"
				lazy
				// key={selectedId}
				paginator={showPaginator ? true : false}
				first={requestParams.first}
				rows={requestParams.rows}
				totalRecords={totalRecords}
				onPage={onPage}
				rowsPerPageOptions={rowsPerPageOptions}
				paginatorTemplate=" PrevPageLink PageLinks NextPageLink  CurrentPageReport RowsPerPageDropdown"
				currentPageReportTemplate={`Showing {first} to {last} of ${totalRecords} Items`}
				scrollable
				scrollHeight={tableScrollHeight ? tableScrollHeight : "75vh"}
				loading={isLoading}
				header={headerSearch}
				footer={footer ? footer : undefined}
				emptyMessage="No Record found."
				className={`${showHeaderColumns ? "WireTransferDataTableWithHeaderColumns" : "WireTransferDataTableStyle"
					}`}
				style={{
					position: "sticky",
					top: subMenuVisibility ? "170px" : "128px",
				}}
				// onRowClick={(e: any) => setSelectedRow(e.data)}
				rowClassName={getRowClassName}
			// onRowClick={onRowClickHandler}
			>
				{/* <Column field={"label"} />
				<Column body={delEditArchive}></Column> */}
				{columns &&
					columns.map((x: any, index: any) => (
						<Column
							key={index}
							field={x.field}
							header={x.headerName}
							footer={x.footer}
							align={x.align}
							style={{ fontSize: ".875rem" }}
							body={(rowData: any, row: any) =>
								columnsBody(rowData, row, x)
							}
						/>
					))}
				{!columns && <Column field={"label"} />}
				<Column
					body={(rowData) => delEditArchive(rowData)}
					style={{
						width:
							showDeleteIcon && showArchiveIcon
								? "6.6em"
								: showDeleteIcon || showArchiveIcon
									? "2.8em"
									: "0",
					}}
				/>
			</DataTable>
		</>
	);
};
